function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyBusinessLogoSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Default icon"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#f6f5ff",
      stroke: "rgba(221,221,230,.25)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 6,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 5.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7020",
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7019"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22457",
    d: "m21.979 38.021-1.375-5.5a.687.687 0 0 0-.667-.521H2.063a.687.687 0 0 0-.667.521l-1.375 5.5a.674.674 0 0 0-.021.166 3.487 3.487 0 0 0 1.375 2.791v9.583a.688.688 0 0 0 .688.688h6.874a.688.688 0 0 0 .688-.688V45.75h2.75v4.812a.688.688 0 0 0 .688.688h6.875a.688.688 0 0 0 .688-.688V40.98A3.487 3.487 0 0 0 22 38.189a.674.674 0 0 0-.021-.168zM19.25 49.875h-5.5v-4.813a.688.688 0 0 0-.688-.688H8.937a.688.688 0 0 0-.688.688v4.812H2.75v-8.3a3.05 3.05 0 0 0 .516.055A3.207 3.207 0 0 0 5.844 40.3a3.164 3.164 0 0 0 5.156 0 3.164 3.164 0 0 0 5.156 0 3.207 3.207 0 0 0 2.578 1.33 3.049 3.049 0 0 0 .515-.055zm-.515-9.625a1.985 1.985 0 0 1-1.891-2.063.688.688 0 0 0-1.375 0 1.985 1.985 0 0 1-1.891 2.063 1.985 1.985 0 0 1-1.891-2.063.688.688 0 0 0-1.375 0 1.985 1.985 0 0 1-1.89 2.063 1.985 1.985 0 0 1-1.891-2.063.688.688 0 0 0-1.375 0 1.985 1.985 0 0 1-1.891 2.063 1.977 1.977 0 0 1-1.889-1.983L2.6 33.375h16.8l1.224 4.892a1.979 1.979 0 0 1-1.89 1.983z",
    transform: "translate(11 -20)",
    style: {
      fill: "#0102ce"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBusinessLogoSquare);
export default __webpack_public_path__ + "static/media/empty_business_logo_square.91acdf4f920e5ed060587d2131c8ac34.svg";
export { ForwardRef as ReactComponent };